/* tslint:disable */
/* eslint-disable */
/**
 * My Title
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface SiteDiggingConditionResponse
 */
export interface SiteDiggingConditionResponse {
    /**
     * 
     * @type {number}
     * @memberof SiteDiggingConditionResponse
     */
    id?: number;
    /**
     * 
     * @type {string}
     * @memberof SiteDiggingConditionResponse
     */
    name?: string;
    /**
     * 
     * @type {number}
     * @memberof SiteDiggingConditionResponse
     */
    sortOder?: number;
}

/**
 * Check if a given object implements the SiteDiggingConditionResponse interface.
 */
export function instanceOfSiteDiggingConditionResponse(value: object): value is SiteDiggingConditionResponse {
    return true;
}

export function SiteDiggingConditionResponseFromJSON(json: any): SiteDiggingConditionResponse {
    return SiteDiggingConditionResponseFromJSONTyped(json, false);
}

export function SiteDiggingConditionResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): SiteDiggingConditionResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'] == null ? undefined : json['id'],
        'name': json['name'] == null ? undefined : json['name'],
        'sortOder': json['sortOder'] == null ? undefined : json['sortOder'],
    };
}

export function SiteDiggingConditionResponseToJSON(json: any): SiteDiggingConditionResponse {
    return SiteDiggingConditionResponseToJSONTyped(json, false);
}

export function SiteDiggingConditionResponseToJSONTyped(value?: SiteDiggingConditionResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'name': value['name'],
        'sortOder': value['sortOder'],
    };
}

